





































import Vue from 'vue';
import axios from 'axios';

interface FormProp {
    hsProp: string;
    formField: string;
}

interface HSProp {
    name: string;
    label: string;
}

export default Vue.extend({
    name: 'AddEditFillerTemplate',
    props: ['name', 'isClone'],
    data() {
        return {
            formData: {
                name: '',
                contactProps: [] as Array<FormProp>,
                companyProps: [] as Array<FormProp>,
                file: ''
            },
            isLoaded: false,
            isNew: true,
            contactHSPropInput: '',
            contactPDFFieldInput: '',
            companyHSPropInput: '',
            companyPDFFieldInput: '',
            submitting: false,
            contactHSPropSearchInput: '',
            contactHSProps: [] as Array<HSProp>,
            contactHSPropSearchResults: [] as Array<HSProp>,
            companyHSPropSearchInput: '',
            companyHSProps: [] as Array<HSProp>,
            companyHSPropSearchResults: [] as Array<HSProp>,
        }
    },
    async created() {
        axios.get(this.$store.state.apiUrl + '/hsdata/properties/contacts')
            .then(resp => {
                this.contactHSProps = resp.data;
            });
        axios.get(this.$store.state.apiUrl + '/hsdata/properties/companies')
            .then(resp => {
                this.companyHSProps = resp.data;
            })
        if(this.$props.name != 'MB_NEW') {
            if(!this.$props.isClone) {
                this.isNew = false;
                this.formData.name = this.$props.name;
            }
            
            await axios.get(this.$store.state.apiUrl + '/filler/templates/' + encodeURIComponent(this.$props.name))
                .then(resp => {
                    resp.data.fields.forEach((field: any) => {
                        if(field.Type == 'CONTACT') {
                            this.formData.contactProps.push({
                                hsProp: field.HSProp,
                                formField: field.FormField
                            })
                        } else {
                            this.formData.companyProps.push({
                                hsProp: field.HSProp,
                                formField: field.FormField
                            })
                        }
                    })
                })
                .catch(e => {
                    console.log(e);
                });
        }
        this.isLoaded = true;
    },
    methods: {
        closeEdit() {
            this.$emit('closeAddEdit');
        },
        onFileChange() {
            this.formData.file = (this.$refs.file as any).files[0];
            console.log(this.formData.file);
        },
        async submit() {
            this.submitting = true;
            const templateName = this.formData.name.replace(/ /g, "_");
            if(this.isNew) {
                if(!this.formData.file) {
                    alert("No PDF template attached.");
                    this.submitting = false;
                    return;
                }

                let exists = false;
                await axios.get(this.$store.state.apiUrl + '/filler/templates/' + encodeURIComponent(templateName))
                    .then(resp => {
                        if(resp.data.template) {
                            exists = true;
                        }
                    })
                    .catch(e => {
                        console.log(e);
                    });
                if(exists) {
                    alert("There is already a template with this name.");
                    this.submitting = false;
                    return;
                }
            }

            if(this.formData.contactProps.length == 0 && this.formData.companyProps.length == 0) {
                alert("Must include property fields");
                this.submitting = false;
                return;
            }

            if(!this.formData.name) {
                alert('Must include name');
                this.submitting = false;
                return;
            }

            const formData = new FormData();
            formData.set('name', this.formData.name.replace(/ /g, "_"));
            formData.set('contactProps', JSON.stringify(this.formData.contactProps));
            formData.set('companyProps', JSON.stringify(this.formData.companyProps));
            formData.set('isNew', '' + this.isNew);
            formData.append('file', this.formData.file);
            axios.post(this.$store.state.apiUrl + '/filler/template', formData)
                .then(resp => {
                    if(this.isNew) {
                        alert("Template added!");
                    } else {
                        alert("Template updated!");
                    }
                    
                    this.$emit('closeAddEdit');
                })
                .catch(e => {
                    alert("There was an error.");
                    this.submitting = false;
                })
        },
        addContactProp() {
            this.formData.contactProps.push({
                hsProp: this.contactHSPropInput,
                formField: this.contactPDFFieldInput
            });
            this.contactHSPropInput = '';
            this.contactPDFFieldInput = '';
        },
        addCompanyProp() {
            this.formData.companyProps.push({
                hsProp: this.companyHSPropInput,
                formField: this.companyPDFFieldInput
            });
            this.companyHSPropInput = '';
            this.companyPDFFieldInput = '';
        },
        removeContactProp(i: number) {
            this.formData.contactProps.splice(i, 1);
        },
        removeCompanyProp(i: number) {
            this.formData.companyProps.splice(i, 1);
        },
        contactHSPropSearch() {
            if(!this.contactHSPropSearchInput) {
                this.contactHSPropSearchResults = [];
            } else {
                const nameLower = this.contactHSPropSearchInput.toLowerCase();
                this.contactHSPropSearchResults = this.contactHSProps.filter(c => {
                    return c.label.toLowerCase().includes(nameLower);
                })
            }
        },
        setHSContactProp(name: string) {
            this.contactHSPropInput = name;
        },
        companyHSPropSearch() {
            if(!this.companyHSPropSearchInput) {
                this.companyHSPropSearchResults = [];
            } else {
                const nameLower = this.companyHSPropSearchInput.toLowerCase();
                this.companyHSPropSearchResults = this.companyHSProps.filter(c => {
                    return c.label.toLowerCase().includes(nameLower);
                })
            }
        },
        setHSCompanyProp(name: string) {
            this.companyHSPropInput = name;
        }
    }
})
